import { render, staticRenderFns } from "./ServiceTypeManagement.vue?vue&type=template&id=46978e22&"
import script from "./ServiceTypeManagement.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeManagement.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeManagement.vue?vue&type=style&index=0&id=46978e22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports